import { IVehicleRemindersHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useVehicleReminders = (vin: string | undefined): IVehicleRemindersHook => {
  const { reminderStore } = useStore();
  const { vehicleReminders, vehicleLoading } = reminderStore;

  useEffect(() => {
    reminderStore.clearVehicleReminders();

    return () => {
      reminderStore.clearVehicleReminders();
    };
  }, [reminderStore]);

  useEffect(() => {
    vin && reminderStore.getVehicleReminders(vin);
  }, [reminderStore, vin]);

  return {
    vehicleReminders: Array.from(vehicleReminders.values()),
    loading: vehicleLoading,
  };
};
